// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"error","473":"responsive","522":"ui","535":"login","685":"register","790":"forms","930":"tables"}[chunkId] || chunkId) + "-legacy." + {"41":"f11327c5","64":"835d1353","473":"4c1f1324","522":"2ba075f9","535":"402991d9","685":"84ce2465","790":"445ea224","872":"18a4e236","930":"a6afaca3"}[chunkId] + ".js";
};